export const flightsFaq = [
    {
        heading: 'How to search and book cheap flights on Cleartrip?',
        values: [
            {
                type: 'text',
                value: 'Looking for flights and booking flight tickets is simple and seamless on Cleartrip.'
            },
            {
                type: 'list',
                values: [
                    {
                        type: 'text',
                        value: 'Enter source and destination city/airport'
                    },
                    {
                        type: 'text',
                        value: 'Select the date of travel'
                    },
                    {
                        type: 'text',
                        value: 'Choose the number of travellers'
                    }
                ]
            },
            {
                type: 'space'
            },
            {
                type: 'text',
                value: 'Hit enter and there you go! You have a search list of all the flights available, sorted according to price. You can further filter your search by choosing preferences and filters like time, duration, number of stops, and by airlines or even look for other dates simply by clicking on the calendar on the right side of the page.'
            }
        ]
    },
    {
        heading: 'How to make flexible flight bookings with changeable dates?',
        values: [
            {
                type: 'text',
                value: 'While making your flight booking, make sure to select the ‘CT Flex’ or ‘CT Flexmax’ option before you confirm the air ticket. At a minimal cost, this allows you to modify your flight booking dates and airlines. So in case of any change in plans, Cleartrip has got you covered!'
            }
        ]
    },
    {
        heading: 'How to cancel flights online on Cleartrip?',
        values: [
            {
                type: 'text',
                value: 'In case you wish to cancel your booking due to any reason, simply -'
            },
            {
                type: 'list',
                values: [
                    {
                        type: 'text',
                        value: 'Select the trip you want to cancel'
                    },
                    {
                        type: 'text',
                        value: 'Click on the “Cancellations” link'
                    },
                    {
                        type: 'text',
                        value: 'Select the passengers to cancel the booking for. Then hit “Review cancellation”'
                    },
                    {
                        type: 'text',
                        value: 'Review passenger selection and refund amount'
                    },
                    {
                        type: 'text',
                        value: 'Click on “Yes, cancel now”'
                    }
                ]
            },
            {
                type: 'space'
            },
            {
                type: 'text',
                value: 'That’s it – you’re done! Sit back and wait for your refund that’s guaranteed to be processed within 24 hours.'
            },
            {
                type: 'text',
                value: 'While making your flight booking, select the ‘CT Flexmax’ option before you confirm the air ticket, to cancel flight bookings without having to pay hefty cancellation charges!'
            }
        ]
    },
    {
        heading: 'What are the benefits of booking flights online with Cleartrip?',
        values: [
            {
                type: 'text',
                value: 'Get the best flight fares with exciting flight offers on your air ticket when you book with Cleartrip. Unmissable sales and deals like Travel Max Sale, Big Travel Sale, Cleartrip Tatkaal, etc. offer never-seen-before discounts that help you book flights at affordable rates. Best flight discounts await you when you book with bank cards like ICICI, Bank of Baroda, HDFC, Axis, Kotak etc.'
            }
        ]
    }
]

export const ctFlightsFeatures = [
    {
        heading: 'CT Flexmax',
        value: 'Reschedule or cancel your domestic flight booking for free up to 24 hours before departure.'
    },
    {
        heading: 'CT Flex',
        value: 'Amend your domestic flight booking against your date of travel and choice of airline. Say hello to flexible flight bookings!'
    },
    {
        heading: 'Medi-cancel refund',
        value: 'Cancel your domestic flight booking easily on valid medical grounds and get up to ₹3500 against airline cancellation charges per passenger per segment.'
    },
    {
        heading: 'International travel insurance',
        value: 'Get stress-free coverage against a vast range of uncertainties for all international destinations at only ₹89 per user per day.'
    }
]

export const ctFeatures = [
    {
        heading: 'CT Flexmax',
        value: 'Reschedule or cancel your domestic flight booking for free up to 24 hours before departure.'
    },
    {
        heading: 'CT Flex',
        value: 'Amend your domestic flight booking against your date of travel and choice of airline. Say hello to flexible flight bookings!'
    },
    {
        heading: 'Easy hotel cancellation',
        value: 'Cancel your hotel stay easily. Zero fees on hotel cancellations up to 24 hours before check-in on 20k+ hotels.'
    },
    {
        heading: 'Instant refund initiation',
        value: 'All refunds on flight and hotel cancellations are initiated instantly.'
    },
    {
        heading: 'Medi-cancel refund',
        value: 'Cancel your domestic flight booking easily on valid medical grounds and get up to ₹3500 against airline cancellation charges per passenger per segment.'
    },
    {
        heading: 'International travel insurance',
        value: 'Get stress-free coverage against a vast range of uncertainties for all international destinations at only ₹89 per user per day.'
    },
    {
        heading: 'Special Fares For Armed Personnel, Senior Citizens and Student travellers',
        value: 'Cleartrip introduces discounted fares for armed personnel, senior citizens and students on domestic flights. Additional discounts with coupon codes.'
    }
]

export const cleartripHomeFaq = [
    {
        heading: 'What are the best offers available for travel bookings on Cleartrip?',
        values: [
            {
                type: 'text',
                value: 'Get the best offers on hotels and flights using bank cards such as HDFC, ICICI, Bank of Baroda, Federal Bank, etc. You can also grab amazing discounts during our exciting sale events. Apart from this, find unmissable deals and offers on hotel stays and flight bookings throughout the year.'
            }
        ]
    },
    {
        heading: 'Are there any offers for new users on Cleartrip?',
        values: [
            {
                type: 'text',
                value: 'Firsts are always special. So new users, you get {FLAT 12% off on your airfare} and {up to 18% off on hotels} using code {CTFIRST}. Cleartrip is here to make your {online flight booking} seamless and simple.',
                placeHoldersList: [
                    {
                        type: 'bold',
                        replaceText: 'FLAT 12% off on your airfare',
                        placeHolder: '{FLAT 12% off on your airfare}'
                    },
                    {
                        type: 'bold',
                        replaceText: 'up to 18% off on hotels',
                        placeHolder: '{up to 18% off on hotels}'
                    },
                    {
                        type: 'link',
                        url: '/offers/india/dom-ctfirst',
                        replaceText: 'CTFIRST',
                        placeHolder: '{CTFIRST}'
                    },
                    {
                        type: 'link',
                        url: '/flights',
                        replaceText: 'online flight booking',
                        placeHolder: '{online flight booking}'
                    },
                ]
            }
        ]
    },
    {
        heading: 'How can I find the best deals and discounts on flights and hotels online on Cleartrip?',
        values: [
            {
                type: 'text',
                value: 'With Cleartrip, there are multiple deals available for your online flight and {hotel booking}. Whenever you select a hotel or a flight ticket, you can find the best available deals mentioned on the booking page. You can then use any of the available deals and coupon codes to avail your offer. Explore all {flight booking discount offers} & {hotels booking discount offers}.',
                placeHoldersList: [
                    {
                        type: 'link',
                        url: '/hotels',
                        replaceText: 'hotel booking',
                        placeHolder: '{hotel booking}'
                    },
                    {
                        type: 'link',
                        url: '/offers/india/hotels',
                        replaceText: 'hotels booking discount offers',
                        placeHolder: '{hotels booking discount offers}'
                    },
                    {   
                        type: 'link',
                        url: '/offers/india/domestic-flights',
                        replaceText: 'flight booking discount offers',
                        placeHolder: '{flight booking discount offers}'
                    }
                ]
            }
        ]
    },
    {
        heading: 'Which is the best time to book flight tickets online?',
        values: [
            {
                type: 'text',
                value: 'There’s no specific right time to book your travel. With Cleartrip, there are deals and offers available on online flight tickets all year round, to make your booking easy and affordable. However, there are many exciting sale events Cleartrip has that offer the best deals on travel such as {Travel Maxx sale, #NoEndWeekend sale, Big Billion Days, Big Travel Sale,} etc. Stay tuned and keep an eye on when the travel sales are and book hotels and flights online for the best price!',
                placeHoldersList: [
                    {
                        type: 'bold',
                        replaceText: 'Travel Maxx sale, #NoEndWeekend sale, Big Billion Days, Big Travel Sale,',
                        placeHolder: '{Travel Maxx sale, #NoEndWeekend sale, Big Billion Days, Big Travel Sale,}'
                    }
                ]
            }
        ]
    }
]